import { useState } from 'react';

import { Avatar, Icon } from '~/components/granular';

function FallbackIcon() {
  return (
    <Avatar size="small">
      <Icon className="h-full w-full bg-gradient-500 p-2" color="white" data-testid="icon" icon="BuildingIcon" />
    </Avatar>
  );
}

export function LogoOrIcon({ logo, isCollapsed }: { logo: string | undefined; isCollapsed: boolean }) {
  const [failed, setFailed] = useState(false);

  if (!logo || failed) {
    return <FallbackIcon />;
  }

  return (
    <Avatar data-testid="logo-container" size={isCollapsed ? 'small' : 'medium'}>
      <img alt="logo" className="object-contain" src={logo} onError={() => setFailed(true)} />
    </Avatar>
  );
}
